<h1>{{"navigation.contact" | translate}}</h1>
<div class="d-flex">
  <div class="address">
    <!--<app-heading [level]="3" text="home.contact.address"></app-heading>-->
    <h2>{{"home.contact.address" | translate}}</h2>
    <p>
      Hecht Contactlinsen GmbH<br>
      Dorfstrasse 2-4<br>
      D-79280 Au bei Freiburg<br>
      Tel. +49 761 40105-0<br>
      Email: <a href="mailto:info@hecht-contactlinsen.de">info@hecht-contactlinsen.de</a><br><br>
  </div>
  <div class="address">
    <p style="margin-top: 40px">
      ASCON Contactlinsen AG<br>
      Schanzenstrasse 1<br>
      CH-3008 Bern<br>
      Tel.: +41 31 382 37 07<br>
      Email: <a href="mailto:info@ascon.ch">info@ascon.ch</a><br><br>
    </p>
  </div>
  <div class="address">
    <p style="margin-top: 40px">
      Hecht Contactlinsen in Österreich<br>
      Meraner Strasse 3<br>
      A- 6020 Innsbruck<br>
      Tel. +43 512 / 58 37 25 -18<br>
      Email: <a href="mailto:info@hecht-contactlinsen.at">info@hecht-contactlinsen.at</a><br>
    </p>
  </div>
  <div class="social">
    <!--<app-heading [level]="3" text="home.contact.social"></app-heading>-->
    <h2>{{"home.contact.social" | translate}}</h2>
    <div class="d-flex flex-row justify-content-between social">
      <a href="https://www.facebook.com/Hecht.Contactlinsen" target="_blank">
        <img src="assets/img/icons/facebook.svg">
      </a>
      <a href="https://twitter.com/HechtContactlin" target="_blank">
        <img src="assets/img/icons/twitter.svg">
      </a>
      <a href="https://www.instagram.com/hechtcontactlinsen/" target="_blank">
        <img src="assets/img/icons/inst.svg">
      </a>
      <a href="https://www.youtube.com/c/Hecht-kontaktlinsenDe" target="_blank">
        <img src="assets/img/icons/youtube.svg">
      </a>
    </div>
  </div>
</div>